export default "__VITE_ASSET__CGGjGOQa__"